var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnNavBackground = function SvgIcnNavBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4998 33.3334H24.4998C31.1665 33.3334 33.8332 30.6667 33.8332 24.0001V16.0001C33.8332 9.33341 31.1665 6.66675 24.4998 6.66675H16.4998C9.83317 6.66675 7.1665 9.33341 7.1665 16.0001V24.0001C7.1665 30.6667 9.83317 33.3334 16.4998 33.3334Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5002 17.3331C17.9729 17.3331 19.1668 16.1392 19.1668 14.6664C19.1668 13.1937 17.9729 11.9998 16.5002 11.9998C15.0274 11.9998 13.8335 13.1937 13.8335 14.6664C13.8335 16.1392 15.0274 17.3331 16.5002 17.3331Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06055 29.2668L14.6339 24.8535C15.6872 24.1468 17.2072 24.2268 18.1539 25.0402L18.5939 25.4268C19.6339 26.3202 21.3139 26.3202 22.3539 25.4268L27.9005 20.6668C28.9405 19.7735 30.6205 19.7735 31.6605 20.6668L33.8339 22.5335",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnNavBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_nav_background.2a946d3b.svg";
export { ForwardRef as ReactComponent };